import { theme } from '../globalStyle/global-styles';
import styled from 'styled-components';

export const DeleteButtonContainer = styled.div`
  padding-top: 16px;
  display: flex;
  align-items: center;
  gap: 10px;

  button#okBtn {
    border-radius: 12px;
    font-family: ${theme.fonts.Medium};
    background-color: ${theme.colours.AntiFlashWhite};
    color: ${theme.colours.black};
    width: 86px;
    height: 36px;
    font-size: 14px;
    font-weight: 400;
    @media (max-width: 767px) {
      width:100% !important;
    }
    &:hover {
      background-color: ${theme.colours.AntiFlashWhite};
    }
    &[type='button'] {
      background-color: ${theme.colours.Danger};
      color: ${theme.colours.white};
    }
  }
`;
